// Module
var code = `<!-- ko using: model -->
<div class="svc-creator-tab__content svc-test-tab__content" data-bind="css: { 'svc-creator-tab__content--with-toolbar' : isPageToolbarVisible }">
  <!-- ko if: survey.isEmpty -->
  <div class="svc-test-tab--empty">
    <svc-surface-placeholder params="name: 'theme', placeholderTitleText: \$data.placeholderTitleText, placeholderDescriptionText: \$data.placeholderDescriptionText"></svc-surface-placeholder>
  </div>
  <!-- /ko -->
  <!-- ko ifnot: survey.isEmpty -->
  <div class="svc-plugin-tab__content">
    <survey-simulator params="model: simulator"></survey-simulator>
    <!-- ko if: showResults -->
    <survey-results params="survey: survey"></survey-results>
    <!-- /ko -->
  </div>
  <!-- /ko -->
  <!-- ko if: isPageToolbarVisible -->
  <div class="svc-plugin-tab__content-actions svc-test-tab__content-actions">
    <!-- ko component: { name: 'sv-action-bar', params: { model: pages } } -->
    <!-- /ko -->
  </div>
  <!-- /ko -->
</div>
<!-- /ko -->`;
// Exports
export default code;